var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"hidden-print-only",staticStyle:{"z-index":"0"},attrs:{"padless":"","absolute":""}},[_c('v-col',{staticClass:"text-right overline",attrs:{"cols":"12"}},[_c('span',{staticClass:"warning"},[_vm._v(_vm._s(_vm.$app_mode))]),_vm._v(" Admin Ver. 2.9.0 | Copyright © "+_vm._s(new Date().getFullYear())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }